@if (data && data.length; as count;) {
  <div class="list-wrap justify-content-lg-end gadget" [ngClass]="{ 'open': open }">
    <div class="title">
      <span translate>{{title}}</span>
    </div>
    <div class="mt-3">
      @for (item of data; track item; let i = $index) {
        @if (item.icon) {
          <div [hidden]="i >= 3 && !open" class="list">
            <div>
              <img src="{{beUrl}}{{imagesPath}}/{{systemName}}/Group_Images/{{item.icon}}_logo.png" title="{{item.Name}}"/>
              <div class="list_sum">{{item.count}}</div>
            </div>
          </div>
        }
      }
      <div class="show_more_less">
        @if (!open && data.length > 3) {
          <button type="button" class="btn btn-primary" (click)="open=true" translate>Show More</button>
        }
        @if (open) {
          <button type="button" class="btn btn-primary" (click)="open=false" translate>Show Less</button>
        }
      </div>
    </div>
  </div>
}
